/**
 * @generated SignedSource<<77b8ecedfccc0a13cd38e375da7fdf80>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "model",
            "variableName": "model"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "active",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "UserAttributesUpdateModal_updateTimeReportingUserMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpdateTimeReportingUserPayload",
                    "kind": "LinkedField",
                    "name": "updateTimeReportingUser",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EdgeOfTimeReportingUser",
                            "kind": "LinkedField",
                            "name": "timeReportingUserEdge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TimeReportingUser",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "UserAttributesUpdateModal_updateTimeReportingUserMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpdateTimeReportingUserPayload",
                    "kind": "LinkedField",
                    "name": "updateTimeReportingUser",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EdgeOfTimeReportingUser",
                            "kind": "LinkedField",
                            "name": "timeReportingUserEdge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TimeReportingUser",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "id",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "62c7add716aa3365f23f2173aacbeb70",
            "id": null,
            "metadata": {},
            "name": "UserAttributesUpdateModal_updateTimeReportingUserMutation",
            "operationKind": "mutation",
            "text": "mutation UserAttributesUpdateModal_updateTimeReportingUserMutation(\n  $model: UpdateTimeReportingUserInput!\n) {\n  updateTimeReportingUser(model: $model) {\n    timeReportingUserEdge {\n      node {\n        active\n        id\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "3e0e3c75b48c529264f81069b80479d4";
export default node;
